import { z } from 'zod';

import { zAbbreviatedMenuRow } from './abbreviatedMenuRow';
import {
  zAbbreviatedMenuProduct,
  zMenuProductCategory,
  zMenuProductSubset,
  zPhoto,
} from './menuProduct';

export const zFlavorsAndEffectsKind = z.object({
  _destroy: z.boolean().optional(),
  id: z.number(),
  kind: z.string(),
});

const zMenuProductForProductsTable = zMenuProductSubset
  .merge(
    zAbbreviatedMenuProduct.omit({
      kind: true,
    })
  )
  .extend({
    actual_weight: z.string().nullable(),
    category: zAbbreviatedMenuProduct.shape.kind,
    content_type: z.string(),
    custom_rows: z.array(zAbbreviatedMenuRow),
    default_product_brand_subtype: z.string().nullable(),
    default_product_description: z.string(),
    default_product_lineage: z.string().nullable(),
    default_product_name: z.string(),
    default_product_image_urls: z.array(zPhoto.pick({ urls: true })),
    effects: z.array(zFlavorsAndEffectsKind),
    flavors: z.array(zFlavorsAndEffectsKind),
    full_name: z.string(),
    is_self_published: z.boolean(),
    inventory_count: z.number(),
    lineage: zMenuProductCategory.or(z.literal('')),
    percent_cbd: z.string().nullable(),
    percent_cbda: z.string().nullable(),
    percent_thc: z.string().nullable(),
    percent_thca: z.string().nullable(),
    pos_product_link: z.string().nullable(),
    pos_sku: z.array(z.array(z.string())),
    photos: z.array(zPhoto).nullish(),
    price_ranges: z
      .record(
        z.object({
          min: z.number().nullable(),
          max: z.number().nullable(),
          out_of_stock: z.boolean().optional(),
        })
      )
      .optional(),
    status: z.string(),
    subcategory: z.string().nullable(),
    unavailable_prices: z.array(
      z.object({
        id: z.number(),
        menu_product_id: z.number(),
        price_id: z.string(),
        price: z.string(),
      })
    ),
    visible: z.boolean().nullable(),
  });

export const zProductIndexResponse = z.object({
  products: z.array(zMenuProductForProductsTable),
  meta: z.object({
    page: z.number(),
    page_total: z.number(),
    per_page: z.number(),
    total: z.number(),
    number_of_pages: z.number(),
    all_product_ids: z.array(z.any()),
  }),
});

export const zProductDetailResponse = z.object({
  product: zMenuProductForProductsTable,
});

export type MenuProductForProductsTable = z.infer<
  typeof zMenuProductForProductsTable
>;

export type ProductIndexResponse = z.infer<typeof zProductIndexResponse>;
